---
id: libs-features-src-keyword-tool-doc
title: Keyword Tool
owner: TBD
status: Draft
lastReviewed: 2026-01-27
visibility: public
tags:
  - keyword-tool
  - keywords
---

## Product Overview

Helps users identify and tailor resume keywords against a job description.

### Primary Workflow
Users add a job title and job description, then review suggested keywords,
confirm relevance, and tailor resume content based on AI-assisted guidance.

### Business Logic
Keyword suggestions are derived from the resume’s stored job description and
are refreshed when plan status or keyword format changes. The experience
switches between a job description form and keyword lists depending on whether
the resume has a job description saved.

### Outcomes
The tool surfaces missing or relevant keywords and guides users toward resume
updates that better align with the target job description.

### Out of Scope
Resume editing, document generation, and job search experiences live outside
this feature module.

## Technical Overview

Renders the keyword tailoring and keyword targeting flows, plus the job
description modal. Uses root stores for keyword status and AI suggestion state,
initializes an active keyword when suggestions are available, and resets keyword
state on unmount. The targeting view swaps between a form and a list based on
whether a job description is present.

### Entry Points
The feature entry point is `libs/features/src/keyword-tool/keyword-tool.tsx`,
which renders the tailoring flow, targeting flow, and job description modal.

### Key Modules
`libs/features/src/keyword-tool/components/keyword-tailoring` manages relevance
and tailoring actions, while `libs/features/src/keyword-tool/components/keyword-targeting`
switches between `keyword-targeting-form` and `keyword-targeting-list` based on
resume data. The modal lives in
`libs/features/src/keyword-tool/components/_modal/job-description.tsx`.

### Data and Services
Keyword suggestion fetching is coordinated by
`libs/features/src/keyword-tool/hooks/use-get-keyword-suggestion.ts` and
`libs/features/src/keyword-tool/hooks/use-fetch-keywords.ts`, which call
`@rezi/utils/fetch-keywords` and persist results on the resume record.

### Integrations and Side Effects
The feature reads and writes keyword data via the root stores and updates the
resume document with `resumesStore.updateResume`. It also reports keyword update
events through `AdvancedUserReporter` when new keywords are fetched.

### Constraints and Risks
The experience depends on the presence of a resume and job description; missing
data results in the form flow and prevents keyword list rendering.

## Changelog

- 2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.
- 2026-01-21: Created.
